import { useBrandStore } from 'stores';
import BillingView from './Billing.View';

const Billing = () => {
  const { brand } = useBrandStore();
  return <BillingView brand={brand} />;
};

export default Billing;
